import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { tenantSlugFromHost } from '../lib/tenant-host';

type ImChannel = 'dingtalk' | 'wecom';

interface TenantBrief {
  slug: string;
  imChannel?: ImChannel;
}

export function useImChannel(): { channel: ImChannel; label: '钉钉' | '企微' } {
  const slug = tenantSlugFromHost(window.location.hostname);
  const { data } = useQuery({
    queryKey: ['auth-tenants'],
    queryFn: () => api.get<unknown, TenantBrief[]>('/auth/tenants'),
    staleTime: 5 * 60_000,
  });
  const channel = slug
    ? data?.find((tenant) => tenant.slug === slug)?.imChannel ?? 'dingtalk'
    : 'dingtalk';

  return { channel, label: channel === 'wecom' ? '企微' : '钉钉' };
}
